
export default {
  methods: {
    updateBookingRouteParam($router, newParam) {
      $router.replace({ params: {step: newParam}, query: $router.currentRoute.query });
    }
  }
};
